import { __assign } from "tslib";
import React from 'react';
import { app as api } from '@ekuaibao/whispered';
import { Tooltip } from '@hose/eui';
import StaffFilter from '../data-grid/StaffFilter';
export var createNodeStaffColumn = function (props, params) {
    if (props === void 0) { props = {}; }
    if (params === void 0) { params = { dataIndex: 'nodeState.id' }; }
    var EkbIcon = api.require('@elements/icon');
    var dataIndex = (params === null || params === void 0 ? void 0 : params.dataIndex) || 'nodeState.id';
    return __assign({ key: dataIndex, title: i18n.get('当前审批人'), dataIndex: dataIndex, label: (React.createElement(Tooltip, { placement: "bottom", title: i18n.get('暂不支持打印和导出') },
            React.createElement("span", { style: { color: '#333' } }, i18n.get('当前审批人')),
            React.createElement(EkbIcon, { name: "EDico-help" }))), className: 'fs-14', sorter: false, filterType: 'custom', hiddenFilterAction: true, filterStyles: {
            wrapperStyle: {
                border: 'none',
                backgroundColor: 'transparent'
            },
            bodyStyle: {
                padding: '0'
            }
        }, renderFilter: function (props) { return React.createElement(StaffFilter, __assign({}, props)); } }, props);
};
export var createNodeNameColumn = function (props) {
    if (props === void 0) { props = {}; }
    var EkbIcon = api.require('@elements/icon');
    return __assign({ key: 'nodeState.nodeName', title: i18n.get('审批节点'), dataIndex: 'nodeState.nodeName', label: (React.createElement(Tooltip, { placement: "bottom", title: i18n.get('暂不支持打印和导出') },
            React.createElement("span", { style: { color: '#333' } }, i18n.get('审批节点')),
            React.createElement(EkbIcon, { name: "EDico-help" }))), className: 'fs-14', sorter: false }, props);
};
